/**
 * Clés de sections ProduitModal — Lot L-UX-1 (étape 1).
 * Correspondance spec A–P → clés filtre UI (étape 4 branchera le modal).
 */

export const PRODUCT_SECTION_KEYS = Object.freeze({
  PHOTOS: 'photos',
  INFOS: 'infos',
  PRIX: 'prix',
  VENTE_AU_POIDS: 'venteAuPoids',
  PLANCHE_PERSONNES: 'planchePersonnes',
  INGREDIENTS: 'ingredients',
  CATEGORIE: 'categorie',
  CHAMPS_METIER: 'champsMetier',
  STOCK: 'stock',
  COMPOSITION_PIECES: 'compositionPieces',
  OPTIONS: 'options',
  BADGES: 'badges',
  ELEMENTS_COMPOSABLES: 'elementsComposables',
  LIEN_PLATEAUX: 'lienPlateaux',
  TEMPLATES: 'templates',
});

/** Toutes les sections gérées par l'assistant (hors champs internes type limiteTotal). */
export const ALL_PRODUCT_SECTION_KEYS = Object.freeze(
  Object.values(PRODUCT_SECTION_KEYS)
);

/** Libellés commerçant pour récap écran 3. */
export const PRODUCT_SECTION_LABELS = Object.freeze({
  [PRODUCT_SECTION_KEYS.PHOTOS]: 'Photos',
  [PRODUCT_SECTION_KEYS.INFOS]: 'Nom et description',
  [PRODUCT_SECTION_KEYS.PRIX]: 'Prix et TVA',
  [PRODUCT_SECTION_KEYS.VENTE_AU_POIDS]: 'Vente au poids',
  [PRODUCT_SECTION_KEYS.PLANCHE_PERSONNES]: 'Planche par personnes',
  [PRODUCT_SECTION_KEYS.INGREDIENTS]: 'Ingrédients et allergènes',
  [PRODUCT_SECTION_KEYS.CATEGORIE]: 'Catégorie',
  [PRODUCT_SECTION_KEYS.CHAMPS_METIER]: 'Champs spécifiques commerce',
  [PRODUCT_SECTION_KEYS.STOCK]: 'Stock',
  [PRODUCT_SECTION_KEYS.COMPOSITION_PIECES]: 'Plateau à composer (pièces)',
  [PRODUCT_SECTION_KEYS.OPTIONS]: 'Options et variantes',
  [PRODUCT_SECTION_KEYS.BADGES]: 'Badges alimentaires',
  [PRODUCT_SECTION_KEYS.ELEMENTS_COMPOSABLES]: 'Pièces composables',
  [PRODUCT_SECTION_KEYS.LIEN_PLATEAUX]: 'Disponible sur les planches',
  [PRODUCT_SECTION_KEYS.TEMPLATES]: 'Templates',
});
